/* src/app/components/error/error-icon.component.scss */
.warning {
  color: #D3394C;
  margin-left: 4px;
}
.icon-wrapper {
  display: flex;
  height: 100%;
  align-items: center;
}
.mat-mdc-icon-button {
  width: 30px;
}
/*# sourceMappingURL=error-icon.component-77OPWGYA.css.map */
